//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MemberLastName from '../../secondary/account/profile/form/MemberLastName.vue';
import MemberFirstName from '../../secondary/account/profile/form/MemberFirstName.vue';
import MemberWeight from '../../secondary/account/profile/form/MemberWeight.vue';
import MemberHeight from '../../secondary/account/profile/form/MemberHeight.vue';
import PreferredUnits from '../../secondary/account/profile/form/PreferredUnits';
import MemberBirthDate from '../../secondary/account/profile/form/MemberBirthDate.vue';
import MemberGender from '../../secondary/account/profile/form/MemberGender.vue';

export default {
  name: 'Biometrics',
  components: {
    PreferredUnits,
    MemberLastName,
    MemberFirstName,
    MemberWeight,
    MemberHeight,
    MemberGender,
    MemberBirthDate,
  },
  props: {
    value: {
      default: {
        height: null,
        weight: null,
        firstName: null,
        lastName: null,
        prefersMetric: null,
        birthDate: null,
        gender: null,
      },
    },
  },
  computed: {
    isValid() {
      return this.$refs.form.isValid;
    },
  },
  methods: {
    propagate() {
      this.$emit('input', this.value);
    },
  },
};
